// extracted by mini-css-extract-plugin
export var actionButton = "_wr-2";
export var card = "_wr-0";
export var disambiguationList = "_wr-3";
export var errorCard = "_wr-4";
export var row = "_wr-1";